import { Component } from '@angular/core';

@Component({
  selector: 'app-brouillon-retour-frns',
  templateUrl: './brouillon-retour-frns.component.html',
  styleUrls: ['./brouillon-retour-frns.component.scss']
})
export class BrouillonRetourFrnsComponent {}
